export const environment = {
  production: true,
  apiBaseUrl: '/api',
  disableBiometricAuth: false
};